import React from "react";

const SignupModal = ({ onClose }) => {
  const handleSignup = async (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);

    const response = await fetch("https://jivangaming.in/backend/signup.php", {
      method: "POST",
      body: formData,
    });

    const result = await response.json();

    if (result.status === "success") {
      alert("Signup successful!");
      localStorage.setItem("user", JSON.stringify(result.user));
      onClose(); // close modal
      window.location.href = "/profile"; // or change this
    } else {
      alert(result.message || "Signup failed");
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30 z-50">
      <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md relative">
        <button className="absolute top-2 right-2 text-xl" onClick={onClose}>
          ×
        </button>
        <h2 className="text-2xl font-bold mb-6 text-center">Signup</h2>
        <form onSubmit={handleSignup} className="space-y-4">
          <input
            name="name"
            placeholder="Full Name"
            required
            className="border p-2 w-full"
          />
          <input
            name="email"
            type="email"
            placeholder="Email"
            required
            className="border p-2 w-full"
          />
          <input
            name="password"
            type="password"
            placeholder="Password"
            required
            className="border p-2 w-full"
          />
          <button type="submit" className="bg-black text-white px-4 py-2 w-full">
            Signup
          </button>
        </form>
      </div>
    </div>
  );
};

export default SignupModal;
